import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import DlGroup from "./../models/DlGroup";
import "./App.css";
import "../index.scss";
import "./Sidemenu.scss";

let GroupMenu = null;

const mapStateToProps = state => ({
  dlGroup: state.dlGroup
});
const mapDispatchToProps = null;

GroupMenu = ({ dlGroup }) => {
  let comp = null;
  const gSlug = dlGroup.dlGroupSlug;
  if (gSlug != "") {
    comp = (
      <React.Fragment>
        <div className="points-p">
          <img src="/images/tackice.jpg" alt="citajte o" />
        </div>
        <li data-toggle="collapse" data-target="#service" className="collapsed">
          <Link to={"/g/" + gSlug} className="a-m" style={{marginLeft: "0.4em", marginTop: "0.5em", textTransform: "uppercase"}}>
            {DlGroup.groupTitleGet(gSlug)}
          </Link>
        </li>
        <li data-toggle="collapse" data-target="#service" className="collapsed">
          <Link to={"/g/" + gSlug + "/kd"} className="a-m" style={{ marginLeft: "0.4em" }}
          >
            izložbeni katalozi{" "}
          </Link>
        </li>
        <li data-toggle="collapse" data-target="#new" className="collapsed">
          <Link style={{ marginLeft: "0.4em" }} to={"/g/" + gSlug + "/d"} className="a-m" >
            knjige
          </Link>
        </li>
        <li data-toggle="collapse" data-target="#new" className="collapsed">
          <Link style={{ marginLeft: "0.4em" }} to={"/g/" + gSlug + "/p"} className="a-m" >
            periodika
          </Link>
        </li>
        <li data-toggle="collapse" data-target="#new" className="collapsed">
          <Link style={{ marginLeft: "0.4em" }} to={"/g/" + gSlug + "/hm"} className="a-m" >
            hemeroteka
          </Link>
        </li>
        <li data-toggle="collapse" data-target="#new" className="collapsed">
          <Link style={{ marginLeft: "0.4em", fontSize: '0.85em' }}  to={"/g/" + gSlug + "/photo-series/ph"} className="a-m" >
            fotodokumentacija
          </Link>
        </li>
        <li data-toggle="collapse" data-target="#new" className="collapsed">
          <Link style={{ marginLeft: "0.4em", fontSize: '0.85em' }}  to={"/g/" + gSlug + "/photo-series/ng"} className="a-m" >
            neknjižna građa
          </Link>
        </li>
        {/* <li data-toggle="collapse" data-target="#new" className="collapsed">
          <Link style={{ marginLeft: "0.4em" }} to={"/"} className="a-m">
            neknjižna građa
          </Link>
        </li>
        <li data-toggle="collapse" data-target="#new" className="collapsed">
          <Link style={{ marginLeft: "0.4em" }} to={"/"} className="a-m">
            strane knjige
          </Link>
        </li> */}
      </React.Fragment>
    );
  }

  return comp;
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupMenu);
